import * as Scrivito from "scrivito";
import React from "react";
import { NewProjectButton } from "./NewProjectButton";
import { ProjectListTitle } from "./ProjectListTitle";

export const ProjectListHeader = Scrivito.connect(() => (
  <div className="d-flex justify-content-between align-items-center py-5_5">
    <ProjectListTitle />
    <NewProjectButton />
  </div>
));
